import { login } from '@/api/login'
import { setToken, removeToken, setRefreshToken, removeRefreshToken } from '@/utils/auth'

const user = {
  state: {
    userName: 'test'
  },
  mutations: {
    set_user_name (state, name) {
      state.userName = name
    }
  },
  actions: {
    // 登录
    Login ({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo).then(response => {
          const data = response.data
          commit('set_user_name', userInfo.userName)
          setToken(data.accessToken)
          setRefreshToken(data.refreshToken)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    Logout ({ commit, state }) {
      return new Promise((resolve, reject) => {
        commit('init_tabs')
        removeToken()
        removeRefreshToken()
        resolve()
      })
    },
    // 前端 登出
    FedLogOut ({ commit }) {
      console.log(123)
      return new Promise(resolve => {
        removeToken()
        resolve()
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js